import { Strategy } from '@oai-frontend-monorepo/types';
import { BidAskMidFn } from '../types/BidAskMidFn';
import calculateFourLegSpreadQuote from './calculateFourLegSpreadQuote';
import calculateSingleLegQuote from './calculateSingLegQuote';
import calculateTwoLegSpreadQuote from './calculateTwoLegSpreadQuote';

export const calculateTradeQuote: BidAskMidFn = ({ legs, strategy }) => {
  if (!strategy || !legs?.length) {
    return undefined;
  }

  switch (strategy) {
    case Strategy.SHORT_STOCK:
    case Strategy.LONG_STOCK:
    case Strategy.LONG_PUT:
    case Strategy.LONG_CALL: {
      return calculateSingleLegQuote({ legs, strategy });
    }

    case Strategy.IRON_CONDOR:
    case Strategy.IRON_BUTTERFLY: {
      return calculateFourLegSpreadQuote({ legs, strategy });
    }

    default: {
      return calculateTwoLegSpreadQuote({ legs, strategy });
    }
  }
};

export default calculateTradeQuote;
